import VideoEmbed from '../../components/aws/programa_re_start/VideoEmbed';
import Cabecera from '../../components/cabecera/Cabecera';
import {
  FaBook, FaCloud, FaAws, FaCode, FaAward,
  FaComments, FaClock, FaUsers, FaTasks
} from 'react-icons/fa';

import logo_restart from '../../assets/images/programa_restart/logo_restart.png';
import { MdLocationOn, MdAccessTime } from 'react-icons/md';
import { FaCheck } from 'react-icons/fa';
import './AWSRestart.css';

import { MdEmail, MdVideocam, MdGroups, MdTouchApp, MdFlashOn, MdCall, MdSchool, MdEmojiEmotions } from 'react-icons/md';
import FormularioPostularStar from '../../components/aws/programa_re_start/FormularioPostularStart'
export default function AWSRestart() {
  return (
    <div style={{ backgroundColor: 'white', color: 'white', margin: '0px', fontFamily: 'Raleway' }}>
      <Cabecera 
        titulo={[
          "Programa ", <label key="aws" style={{ color: '#912B2B', fontWeight: '600' }}>AWS</label>, " re/Start"
        ]}
        icono={logo_restart}
        descripcion="Formación en la nube y fundamentos de TI de AWS"
      />
      <div
        style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '4rem',
            padding: '2rem 1rem',
            backgroundColor: 'white',
            color: '#333',
            textAlign: 'left',
            flexWrap: 'wrap',
            marginTop: '2rem'
        }}
        >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', maxWidth: '350px' }}>
            <MdLocationOn size={40} color="#912b2b" />
            <div>
            <h4 style={{ color: '#912b2b', fontWeight: 'bold', margin: 0 }}>Ciudad</h4>
            <p style={{ margin: 0 }}>
                Actualmente este programa se<br />realiza en modalidad híbrida
            </p>
            </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', maxWidth: '350px' }}>
            <MdAccessTime size={40} color="#912b2b" />
            <div>
            <h4 style={{ color: '#912b2b', fontWeight: 'bold', margin: 0 }}>Duración</h4>
            <p style={{ margin: 0 }}>
                Este programa constará<br />de 12 semanas
            </p>
            </div>
        </div>
    </div>
    <div style={{
        width: '100%',
        backgroundColor: 'white',
        padding: '2rem 1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '3rem',
        flexWrap: 'wrap',
        marginBottom: '1rem',
        }}>
        <div style={{ display: 'flex', alignItems: 'center', height: '80px' }}>
            <img
                src={require('../../assets/images/programa_restart/AWS_Restart_Logo.png')}
                alt="Logo AWS re/Start"
                style={{
                    height: '60px',
                    objectFit: 'contain',
                    display: 'block',
                    marginTop: '20px'
                }}
            />
        </div>

        <div className="divider-logo" style={{ width: '1.5px', height: '100px', backgroundColor: '#ccc' }} />


        <div style={{ display: 'flex', alignItems: 'center', height: '80px' }}>
            <img
            src={require('../../assets/images/programa_restart/logo_rojo_negro.png')}
            alt="Logo Manantial"
            style={{
                height: '80px',
                objectFit: 'contain',
                display: 'block',
                marginTop: '-10px'
            }}
            />
        </div>
    </div>

        <div style={{
            width: '100%',
            backgroundColor: 'white',
            padding: '3rem 1rem',
            textAlign: 'center'
            }}>
            <h2 style={{
                fontSize: '2rem',
                color: '#000000',
                fontWeight: 'bold',
                fontFamily: 'Raleway, sans-serif',
                marginBottom: '1.5rem'
            }}>
                Inicie una <span style={{ color: '#912b2b' }}>carrera en tecnología</span> con AWS re/Start
            </h2>

            <div style={{
                maxWidth: '900px',
                margin: '0 auto'
            }}>
                <p style={{
                fontSize: '1.1rem',
                color: '#000',
                fontFamily: 'Raleway, sans-serif',
                lineHeight: '1.8',
                marginTop: '2rem',
                }}>
                <i>AWS re/Start</i> es un programa gratuito y de modalidad híbrida mediante el cual se desarrollan habilidades técnicas como habilidades blandas, con el objetivo de impulsar su carrera profesional en el ámbito de la computación en la nube. No es necesario tener experiencia en tecnología para solicitarlo y está dirigido a desempleados y subempleados.
                </p>
            </div>
        </div>
        
        <div style={{
            width: '100%',
            backgroundColor: '#e5e1e6',
            color: 'black',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem 1rem',
            flexWrap: 'wrap',
            fontFamily: 'Raleway, sans-serif',
            gap: '2rem'
            }}>
            {/* Texto a la izquierda centrado verticalmente */}
        <div 
            className="awsrestart-highlight-text"
            style={{
                maxWidth: '600px',
                fontSize: '1.2rem',
                lineHeight: '1.6',
                textAlign: 'left'
            }}
        >
            <p style={{ margin: 0 }}>
                <span style={{ color: '#912b2b', fontWeight: 'bold' }}>AWS re/Start</span> y <span style={{ color: '#912b2b', fontWeight: 'bold' }}>Manantial Tecnológico</span> se han unido para ofrecer este programa <b>100% gratuito e híbrido</b>.
            </p>
        </div>

            <div>
                <img
                src={require('../../assets/images/programa_restart/accredited_badge.png')}
                alt="AWS re/Start Accredited Instructor"
                style={{ height: '100px', objectFit: 'contain' }}
                />
            </div>
        </div>

        <div style={{
            width: '100%',
            backgroundColor: 'white',
            padding: '3rem 1rem',
            textAlign: 'center',
            fontFamily: 'Raleway, sans-serif',
            color: '#000'
            }}>
            <div style={{ maxWidth: '900px', margin: '0 auto', lineHeight: '1.8', fontSize: '1.1rem' }}>
                <p>
                A través del aprendizaje basado en escenarios, laboratorios prácticos y cursos, los alumnos <span style={{ color: '#912b2b', fontWeight: '600' }}>adquieren las habilidades que necesitan</span> para un puesto básico en la nube.
                </p>
                <p>
                En el programa, también te centrarás en <span style={{ color: '#912b2b', fontWeight: '600' }}>habilidades profesionales</span> como la comunicación adaptativa, la gestión del tiempo, la creación de currículums y las entrevistas para prepararte para las reuniones y entrevistas con los empleadores.
                </p>
                <p>
                Aprenderá habilidades de informática en la nube y se preparará para la <span style={{ color: '#912b2b', fontWeight: '600' }}>certificación AWS Certified Cloud Practitioner</span> con acceso gratuito a exámenes de práctica y completos.
                </p>
                <p>
                Después de graduarse, Manantial Tecnológico <span style={{ color: '#912b2b', fontWeight: '600' }}>conectará a los estudiantes con posibles empleadores</span> y le ayudará a prepararse para un mejor desempeño en las entrevistas de aplicación a diferentes ofertas de trabajo.
                </p>
            </div>
        </div>
        <div style={{ backgroundColor: 'white', padding: '1rem 1rem', fontFamily: 'Raleway, sans-serif', color: '#333', marginBottom: '5rem', }}>
            <h2 style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#912b2b',
            textAlign: 'center',
            marginBottom: '3rem'
            }}>
            ¿Cómo será tu viaje en la nube?
            </h2>

            <div 
                className="grid-journey"
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '2rem',
                    justifyContent: 'center',
                    maxWidth: '1000px',
                    margin: '0 auto',
                    position: 'relative'
                }}
            >
              {[ 
                { icon: <MdEmail size={40} color="#912b2b" />, text: 'Presenta tu solicitud' },
                { icon: <MdVideocam size={40} color="#912b2b" />, text: 'Sesión informativa' },
                { icon: <MdGroups size={40} color="#912b2b" />, text: 'Entrevista' },
                { icon: <MdTouchApp size={40} color="#912b2b" />, text: 'Orientación' },
                { icon: <MdFlashOn size={40} color="#912b2b" />, text: 'Inicio de clases' },
                
                { icon: <MdSchool size={40} color="#912b2b" />, text: 'Graduación' },
                { icon: <MdCall size={40} color="#912b2b" />, text: 'Conexión con empleadores' },
                { icon: <MdEmojiEmotions size={40} color="#912b2b" />, text: 'Avanza en tu carrera en la nube' },
            ].map((item, index) => (
                <div key={index} style={{
                    width: '100%',
                    maxWidth: '220px',
                    height: '180px',
                    backgroundColor: 'white', 
                    borderRadius: '12px',
                    padding: '1.2rem 1rem',
                    textAlign: 'center',
                    boxShadow: '0 10px 12px rgba(0, 0, 0, 0.15)', 
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    cursor: 'default',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0, 0, 0, 0.2)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.15)';
                }}
                >
                {/*<div style={{
                    position: 'absolute',
                    top: '15px',
                    left: '15px',
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    backgroundColor: '#332d2a',
                    color: 'white',
                    fontSize: '1.2rem',
                    fontFamily: 'Raleway, sans-serif',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {index + 1}
                </div>*/}

                <div style={{ marginBottom: '0.5rem' }}>{item.icon}</div>
                <p style={{ fontSize: '0.95rem', margin: 0 }}>{item.text}</p>

                {(index !== 3 && index !== 7) && (
                    <div 
                        className="aws-journey-line"
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '-1rem',
                            width: '2rem',
                            height: '2px',
                            backgroundColor: '#C03D2A',
                            transform: 'translateY(-50%)'
                        }} 
                    />
                )}
                </div>
            ))}
            </div>
        </div>

            <VideoEmbed containerStyle={{ padding: '0 1rem' }} />
            <div style={{ backgroundColor: '#ffffff', padding: '3rem 0' }}>
                <div
                    className="requisitos-flex"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        maxWidth: '900px',
                        margin: '0 auto',
                        gap: '3rem',
                        padding: '0 1rem',
                    }}
                >
                    <div style={{ flex: '1', textAlign: 'left' }}>
                        <h2
                            style={{
                            color: '#912b2b',
                            fontSize: '1.8rem',
                            lineHeight: '1.4',
                            margin: 0,
                            fontWeight: 'bold',
                            marginTop: '4rem',
                            }}
                        >
                            ¿Cuáles son los <br />
                            requisitos para <br />
                            postular?
                        </h2>
                    </div>

                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {[
                            'Ser mayor de 18 años',
                            'Acceso a un ordenador e internet',
                            'Interés en trabajar en la industria tecnológica',
                            'Encontrarse desempleado o subempleado'
                        ].map((texto, index) => (
                            <div
                                key={index}
                                style={{
                                    border: '2px solid #912b2b',
                                    borderRadius: '8px',
                                    padding: '0.8rem 1rem',
                                    color: '#000000',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.8rem',
                                }}
                                >
                                <FaCheck color="#912b2b" size={20} style={{ minWidth: 20, minHeight: 20, width: 20, height: 20 }} />
                                {texto}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div style={{
                backgroundColor: 'white',
                padding: '4rem 1rem',
                fontFamily: 'Raleway, sans-serif',
                color: '#333',
                textAlign: 'center'
                }}>
                <h2 style={{
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    marginBottom: '1rem'
                }}>
                    ¿Qué <span style={{ color: '#912b2b' }}>conocimientos</span> aprenderé?
                </h2>

                <p style={{
                    maxWidth: '850px',
                    margin: '0 auto',
                    fontSize: '1.1rem',
                    lineHeight: '1.8',
                    marginBottom: '6rem',
                }}>
                    A través de sesiones prácticas interactivas, aprenderás habilidades técnicas, de comportamiento y de mentalidad que te prepararán para lanzar una carrera en la nube.
                </p>
            </div>
            <div style={{
                width: '100%',
                backgroundColor: 'white',
                padding: '4rem 1rem',
                fontFamily: 'Raleway, sans-serif',
                color: '#fff',
                marginBottom: '3rem',
                marginTop: '-10rem',
                }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

                    <h3 style={{ color: '#232F3E', fontSize: '1.5rem', marginBottom: '2rem', textAlign: 'center', fontWeight: 'bold' }}>
                    Conocimientos técnicos
                    </h3>

                    <div className="grid-tech">
                        {[ 
                            { text: 'Conocimientos técnicos', icon: <FaBook size={30} /> },
                            { text: 'Computación en la nube', icon: <FaCloud size={30} /> },
                            { text: 'Nube de AWS', icon: <FaAws size={30} /> },
                            { text: 'Lenguajes de programación', icon: <FaCode size={30} /> },
                            { text: 'Certificación AWS', icon: <FaAward size={30} /> },
                        ].map((item, idx) => (
                            <div key={idx}
                            style={{
                                backgroundColor: '#232F3E',
                                borderRadius: '12px',
                                padding: '2rem 1rem',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'transform 0.2s ease',
                                height: '100%'
                            }}
                            onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-5px)' }}
                            onMouseOut={e => { e.currentTarget.style.transform = 'none' }}
                            >
                            <div style={{ marginBottom: '1rem', color: '#fff' }}>{item.icon}</div>
                            <div style={{
                                fontSize: '0.80rem',
                                color: '#fff',
                                textAlign: 'center',
                                marginTop: '0.5rem',
                                width: '100%s',
                                display: 'flex',
                                justifyContent: 'center'
                                }}>
                                <p style={{ margin: 0 }}>{item.text}</p>
                            </div>

                            </div>
                        ))}
                        </div>

                    <h3 style={{ color: '#912b2b', fontSize: '1.5rem', marginBottom: '2rem', textAlign: 'center', fontWeight: 'bold', marginTop: '5rem' }}>
                    Habilidades blandas y de empleabilidad
                    </h3>

                    <div className="grid-softskills">
                        {[ 
                            { text: 'Comunicación eficaz', icon: <FaComments size={26} /> },
                            { text: 'Gestión del tiempo', icon: <FaClock size={26} /> },
                            { text: 'Resolución de problemas', icon: <FaTasks size={26} /> },
                            { text: 'Trabajo en equipo', icon: <FaUsers size={26} /> },
                        ].map((item, idx) => (
                            <div key={idx}
                            style={{
                                backgroundColor: '#912b2b',
                                borderRadius: '12px',
                                padding: '2rem 1rem',
                                color: 'white',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'transform 0.2s ease'
                            }}
                            onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-5px)' }}
                            onMouseOut={e => { e.currentTarget.style.transform = 'none' }}
                            >
                            <div style={{ marginBottom: '2rem' }}>{item.icon}</div>
                            <span style={{ fontSize: '0.95rem' }}>{item.text}</span>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
            <FormularioPostularStar />
    </div>
  );
}
